<template>
  <div class="container" v-loading.fullscreen.lock.body="fullScreenLoading">
    <el-row :gutter="10" v-if="currentDishModel">
      <el-row :gutter="5" class="class-dish">
        <el-col :span="14">
          <el-card v-if="currentDishModel" class="box-card">
            <div slot="header" class="clearfix">
              <h3 class="header-title">
                第<span class="danger-text">{{currentIndex + 1}}</span><span>/{{`${dishModelCount}`}}个碗</span>
                名称:
                {{
                  currentDishModel && currentDishModel.dish_name
                    ? currentDishModel.dish_name
                    : "暂无名称"
                }}
              </h3>
              <el-badge class="mark" :value="currentClassImages.length">
                <el-tag type="success">总计</el-tag>
              </el-badge>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <el-badge class="mark" :value="deletedImages.length">
                <el-tag type="danger">已纠错</el-tag>
              </el-badge>
              <div class="btn-wrapper-1">
                <span>
                  <el-button
                    type="primary"
                    :disabled="currentIndex < 1"
                    @click="preDishModel"
                  >上一个</el-button>
                  <el-button
                    type="primary"
                    :disabled="currentIndex === dishModelCount - 1"
                    @click="nextDishModel"
                  >下一个
                  </el-button>
                </span>
              </div>
            </div>
            <classDishWrapper :image="currentDishModel" class="class-dish-wrapper"></classDishWrapper>
          </el-card>
          <span v-else>暂无例图!</span>
        </el-col>
      </el-row>
      <h2 class="process-title">
        <!-- // 自查 -->
        <span> 符合本碗碟的图片 <el-tag type="success">总计 <el-badge class="mark" :value="12"/></el-tag></span>
        <!-- 审查 -->
      </h2>
      <imageCheckWrapperforNewTask
        ref="imageCheckWrapperforNewTask"
        v-if="currentClassImages.length > 0"
        :images="currentClassImages"
        :current_class_id="currentDishModel.class_id"
        @pageChange="pageChange"
      >
      </imageCheckWrapperforNewTask>
      <h3 class="tip-wrapper" v-else>
        当前例图暂无图片
        <el-button
          type="primary"
          :disabled="currentIndex < 1"
          @click="preDishModel"
        >上一个例图</el-button>
        <el-button
          type="primary"
          :disabled="currentIndex === dishModelCount - 1"
          @click="nextDishModel"
        >下一个例图</el-button>
      </h3>
    </el-row >
    <el-row :gutter="10" v-else> <span>暂无标准例图</span> </el-row>
  </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
import imageCheckWrapperforNewTask from './imageWrapperNoChecking';
import classDishWrapper from '_c/classDishWrapper';

export default {
  name: 'checkResult',
  components: {
    imageCheckWrapperforNewTask,
    classDishWrapper
  },
  data () {
    return {
      backDataAcc: [],
      currentIndex: 0,
      checkFailReasonShow: false,
      checkFailReason: '',
      detectedData: {},
      isLastPage: false,
      deletedImages: [],
      fullScreenLoading: false
    };
  },
  mounted () {
    this.setSubTitle('新建任务前审查');
    // this.getBackImages();
  },
  methods: {
    ...mapMutations([
      'emitLoading',
      'removeLoading',
      'setSubTitle'
    ]),
    nextDishModel () {
      if (this.currentIndex < this.modelList.length) {
        this.currentIndex++;
      }
    },
    // 上一个例图
    preDishModel () {
      if (this.currentIndex > 0) {
        this.currentIndex--;
      }
    }
  },
  computed: {
    ...mapGetters([
      'listQuery',
      'userinfo'
    ]),
    imageList () {
      if (this.$route.params && this.$route.params.data) {
        return this.$route.params.data;
      }
      return [];
    },
    // modelList () {
    //   try {
    //     return this.unCheckedList.map(a => {
    //       if (!a.dish_name && a.dish_native_name) {
    //         a.dish_name = a.dish_native_name + '(碗碟库)';
    //       }
    //       return this.$_.pickBy(a, (val, key) => {
    //         return key !== 'marked_img_list';
    //       });
    //     });
    //   } catch (e) {
    //     console.log(e);
    //     return [];
    //   }
    // },
    currentClassImages () {
      if (this.currentDishModel) {
        return this.unCheckedList[this.currentIndex].marked_img_list;
      } else {
        return [];
      }
    },
    apiKey () {
      return this.userinfo().api_key;
    },
    userGroup () {
      return this.userinfo().userGroup;
    },
    dishModelCount () {
      return this.modelList.length || 0;
    },
    currentDishModel () {
      return this.modelList[this.currentIndex];
    },
    batchImageListUnmarked () {
      return this.markedImageList.filter(image => {
        return !image.class_id;
      });
    },
    batchImagesBlongCurrentModel () {
      return this.markedImageList.filter(image => {
        return image.class_id === this.currentDishModel.class_id;
      });
    },
    batchImageListDelete () {
      return this.markedImageList.filter(image => {
        return image.class_id === '-1';
      });
    }
  },
  watch: {
    currentIndex () {
      this.$refs['imageCheckWrapperforNewTask'].formateCurrentPage();
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .tip-wrapper {
    display: inline-block;
    width: auto;
    padding: 20px;
    border: 2px solid red;
    border-radius: 20px;
  }
  .unMarked-card {
    height: 100%;
  }
  .header-title {
    display: inline-block;
  }
  .box-card {
    .btn-wrapper-1 {
      display: inline-block;
      margin-top: -10px;
      float: right;
    }
  }
  .btn-wrapper {
    padding-top: 50px;
    width: 80%;
    .btn-wrapper-1 {
      display: inline-block;
      margin-top: -10px;
      float: right;
    }
  }
  .class-dish-wrapper {
    width: 200px;
    height: 200px;
  }
  .image-wrapper-1 {
    width: 100%;
    height: 150px;
    .image-item {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
    .image-item-wrapper {
      display: inline-block;
      width: 20px;
      height: 20px;
      .image-item {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      .big-img {
        .big-img-wrapper {
          position: relative;
          .btn {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }
  .process-title {
    .strong-text {
      color: #ff0000;
    }
  }
}
</style>
